import { useTranslation } from 'react-i18next';
import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  const { t } = useTranslation();

  return (
    <section id="features" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            {t('home.features.title')}
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
            {t('home.features.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <article
              key={feature.id}
              className="group p-6 md:p-7 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}